import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Login } from "./components/Login/Login";
import { Signup } from "./components/Signup/Signup";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Record } from "./components/Record/Record";
import AllStates from "./context/allStates";
import MainPage from "./Routes/MainPage";
import ProtectedRouts from "./Routes/ProtectedRouts";
import Analisys from "./components/Analisys/Analisys";
import Budgets from "./components/Budget/Budgets";
import Accounts from "./components/Accounts/Accounts";
import Categories from "./components/Categories/Categories";
import ContactTransaction from "./components/ContactTransaction/ContactTransaction";
import Dashboard from "./components/Dashboard/Dashboard";
import Profile from "./components/Profile/Profile";
import LandingPage from "./components/LandingPage/LandingPage";

function App() {
  return (
    <>
      <Router>
        <AllStates>
          <div style={{ marginTop: "55px" }}>
            <Routes>
              <Route element={<LandingPage />} path="/" />
              <Route element={<MainPage />}>
                <Route element={<ProtectedRouts />}>
                  <Route element={<Dashboard />} path="/home" />
                  {/* Record / transaction list */}
                  <Route element={<Record />} path="/record" />
                  <Route element={<Analisys />} path="/analysis" />
                  <Route element={<Budgets />} path="/budgets" />
                  <Route element={<Accounts />} path="/account" />
                  <Route element={<Categories />} path="/categories" />
                  <Route element={<ContactTransaction />} path="/contact" />
                  <Route element={<Profile />} path="/profile" />
                </Route>
              </Route>
              <Route element={<Login />} path="/login" />
              <Route element={<Signup />} path="/signup" />
              <Route
                element={<h1 style={{ marginTop: "50px" }}>Page not found</h1>}
                path="/*"
              />
            </Routes>
          </div>
          <ToastContainer position="top-right" autoClose={3000} theme="colored" />
        </AllStates>
      </Router>
    </>
  );
}

export default App;
